<template>
  <div>
    <v-card class="pa-4">
      <v-card-title class="text-subtitle-1 font-weight-bold justify-center">
        Distribución de ingreso promedio semanal
      </v-card-title>
      <template v-if="loading">
        <v-skeleton-loader type="image" />
      </template>
      <div v-else-if="items.length && !loading" class="d-flex justify-center">
        <donut-chart
          height="350"
          class="w-100"
          :items="items"
          :donut-hole="0.5"
          :only-positive-items="false"
          :options="{
            legend: {
              position: 'right',
              alignment: 'center',
            },
            tooltip: { text: 'label', isHtml: true },
            pieSliceText: 'percentage',
          }"
        />
      </div>
    </v-card>
  </div>
</template>
<script>
  import DonutChart from '@/components/DonutChart.vue';
  export default {
    name: 'WeeklyEarningsDonut',
    components: { DonutChart },
    props: {
      data: {
        type: Object,
        required: true,
      },
      loading: Boolean,
    },
    data() {
      return {
        items: [],
        chartOptions: {},
      };
    },
    watch: {
      data(data) {
        this.initSeries(data);
      },
    },
    methods: {
      initSeries(newData) {
        if (!newData?.rows?.length) return;
        const rows = [...newData.rows];
        rows.pop();
        this.items = rows.map((item) => [
          `${item.concept}`,
          Number(item.average),
        ]);
      },
    },
  };
</script>
